import type { Nullable } from '../types';
import { HTTPError } from '../entities';
import { ErrorResponse } from '../responses/responseTypes';

const errorStatusCode = (response: Nullable<ErrorResponse>): number =>
  response?.status || 0;

const errorTitle = (response: Nullable<ErrorResponse>): string => {
  const defaultTitle = '500 Internal Server Error';

  if (response == null) return defaultTitle;

  return response.data.error || defaultTitle;
};

const errorMessage = (response: Nullable<ErrorResponse>): string => {
  const defaultMessage =
    'Oh no! Something bad happened. Please come back later when we fixed that problem. Thanks.';

  if (response == null) return defaultMessage;

  return response.data.error_description || defaultMessage;
};

const handleErrors = (
  error: HTTPError | TypeError | { response: ErrorResponse }
): Error => {
  if (error instanceof HTTPError || error instanceof TypeError) {
    return error;
  }

  const { response } = error;

  const statusCode = errorStatusCode(response);
  const title = errorTitle(response);
  const message = errorMessage(response);
  const failedService = response.data.payload?.service;
  return new HTTPError(statusCode, title, message, failedService);
};

export default handleErrors;
